/**
 * A casca dos blocos da conversa (#6321): a mesma do card 1-Click do aéreo no Figma (H4 ›
 * «Componentes locais», 6859-96869) — fundo `card`, fio de 1 px em `border`, raio 16, respiro
 * 14, 12 entre as partes e a elevação única da thread (`--shadow-elevation`, #6296). A fala do
 * agente fica fora, acima dela.
 *
 * O raio é o literal do Figma: a escala do ui-kit tem 14 (`xl`) e 18 (`2xl`), sem 16, e qual
 * token vale é decisão do design (ABERTO na #6326).
 */
export const BLOCK_SHELL =
  'flex flex-col gap-3 rounded-[16px] border border-border bg-card p-3.5 shadow-(--shadow-elevation)';
